export const availableCustomButtons = [
	{
		id: 'osloveniPlaceholder',
		type: 'placeholder',  // přidáme typ pro rozlišení
		buttonText: 'Oslovení',
		placeholderText: '{{osloveni}}',
		description: 'Vloží oslovení klienta'
	},
	{
		id: 'zruseniRezervaceInfoPlaceholder',
		type: 'placeholder',  // přidáme typ pro rozlišení
		buttonText: 'Informace o zrušení rezervace',
		placeholderText: '{{zruseniRezervaceInfo}}',
		description: 'Vloží informace o zrušení rezervace'
	},
	{
		id: 'kurzInfo',
		type: 'content',      // přidáme typ pro rozlišení
		buttonText: 'Informace o kurzu',
		description: 'Vloží informace o kurzu',
	},
	//...
];